import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { css } from 'styled-components';
export var removeOutline = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  outline: none;\n\n  &::-moz-focus-inner {\n    border: none;\n  }\n"])));